module.exports = __webpack_public_path__ + "img/signup.c3d040ba.svg";